"use client";

import { useExpandingMenu } from "./expanding-menu.context";
import type { ExpandingMenuContentProps } from "./types/expanding-menu-content.types";
import { expandingMenuContentStyles, expandingMenuContentInnerStyles } from "./styles/expanding-menu-content.styles";
import { useMemo } from "react";

export const ExpandingMenuContent: React.FC<ExpandingMenuContentProps> = (props) => {
  const { children, className, ...rest } = props;

  const { expanded } = useExpandingMenu();

  const styles = expandingMenuContentStyles({ expanded });
  const innerStyles = expandingMenuContentInnerStyles({ className });

  // React 18: inert must be a string attribute (""), not boolean — its presence activates it.
  const inertProps = useMemo(() => {
    return expanded ? {} : { inert: "" };
  }, [expanded]);

  return (
    <div className={styles} {...rest} {...inertProps}>
      <div className="overflow-hidden">
        <div className={innerStyles}>{children}</div>
      </div>
    </div>
  );
};

ExpandingMenuContent.displayName = "ExpandingMenuContent";
